import React, { FC } from 'react'
import { Field, Form, Formik, FormikHelpers, FormikProps } from 'formik'
import { t } from '@lingui/macro'
import { useDispatch } from 'react-redux'
import authenticationActions from 'redux-store/authentication/authentication.actions'
import { forgotPasswordFormValidationSchema } from './ForgotPasswordFormValidationSchema'
import { Button, FormInput } from 'pages/native/onBoarding/components'
import {
  NATIVE_PUBLIC_ROUTES,
  nativePublicPathGenerator
} from 'routes/native/PublicRoutes'
import { useHistory } from 'react-router-dom'
import { useCompanyName } from 'pages/native/onBoarding/context/OnBoardingContext'
import { useAnalytics } from 'utils/analytics/useAnalytics'

import styles from './ForgotPasswordForm.module.scss'

interface ForgotPasswordFormValues {
  userEmail: string
}
interface ForgetPasswordForm {
  onSubmitFormSuccess: () => void
  company?: string
}
export const ForgotPasswordForm: FC<ForgetPasswordForm> = ({
  onSubmitFormSuccess
}) => {
  const { trackGtm, trackClarity } = useAnalytics()
  const dispatch = useDispatch()
  const initialValues: ForgotPasswordFormValues = {
    userEmail: ''
  }
  const onSubmit = async (
    values: ForgotPasswordFormValues,
    formikHelpers: FormikHelpers<any>
  ) => {
    const submitValues = { ...values }
    formikHelpers.setSubmitting(true)
    dispatch(
      authenticationActions.sendEmail(submitValues.userEmail.toLowerCase())
    )
    trackGtm('forgot_password_requested_app')
    trackClarity('forgot_password_requested_app')

    onSubmitFormSuccess()
    formikHelpers.setSubmitting(false)
  }

  const history = useHistory()
  const { value: company } = useCompanyName()

  return (
    <div className={styles.ForgotPasswordFormContainer}>
      <Formik
        initialValues={initialValues}
        validationSchema={forgotPasswordFormValidationSchema}
        validateOnChange
        onSubmit={onSubmit}
      >
        {(formik: FormikProps<any>) => {
          return (
            <Form>
              <div className={styles.Form}>
                <Field
                  component={FormInput}
                  id="userEmail"
                  name="userEmail"
                  label={t`Email`}
                  placeholder={t`Eg: john@email.com`}
                  type="email"
                  isRequired
                  value={formik.values.userEmail}
                  isValid={!formik.errors.userEmail}
                  validationMessage={formik.errors.userEmail}
                  onChange={formik.handleChange}
                />

                <Button
                  label={t`Send`}
                  variant="filled"
                  theme="primary"
                  type="submit"
                  className={styles.SendButton}
                  disabled={!formik.isValid || formik.isSubmitting}
                />

                {/* bring to Register form */}
                <Button
                  variant="text"
                  theme="support"
                  textAlign="left"
                  onClick={() =>
                    history.push(
                      nativePublicPathGenerator(
                        NATIVE_PUBLIC_ROUTES.ON_BOARDING.WELCOME,
                        company
                      )
                    )
                  }
                  label={
                    <div className={styles.TextInline}>
                      <span>{t`Ready to join?`} </span>
                      <span
                        className={styles.ClickableText}
                      >{t`Sign up here!`}</span>
                    </div>
                  }
                />

                {/* bring to Login form */}
                <Button
                  variant="text"
                  theme="support"
                  textAlign="left"
                  onClick={() =>
                    history.push(
                      nativePublicPathGenerator(
                        NATIVE_PUBLIC_ROUTES.AUTH.LOGIN,
                        company
                      )
                    )
                  }
                  label={
                    <div className={styles.TextInline}>
                      <span>{t`Do you already have an account?`} </span>
                      <span
                        className={styles.ClickableText}
                      >{t`Login here.`}</span>
                    </div>
                  }
                />
              </div>
            </Form>
          )
        }}
      </Formik>
    </div>
  )
}
